module.exports = __webpack_public_path__ + "img/South Korea.64875be0.gif";